module.exports = "pegasus/assets/marsh-logo.png";